import { ToastrService } from "ngx-toastr";
// import { SharedService } from "./../../services/shared.service";
import { ApiService } from "src/app/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "./../../services/account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CompanyList, CompanyListWithUpdates } from "./../../models/company-list";
import { ChangeDetectorRef, Component, Inject, Input, NgZone, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SignalRService } from "src/app/services/signalr.service";
import Swal from "sweetalert2";
import {
  Account,
  ClientDataPortfolio,
  PortfolioElement,
  Profile
} from "src/app/screens/user-profile/client-data";
import { UrlConstants } from "src/app/models/urlConstants";
import { SharedService } from "src/app/services/shared.service";
import { CompanyDetails } from "src/app/models/company-details";
import { DatePipe, formatNumber } from "@angular/common";
import {
  MarketWatchDetailService,
  StockDetail,
} from "src/app/services/market-watch-detail.service";
import { InvestmentAmount } from "src/app/models/investment-amount";
import { CommissionResponse } from "src/app/models/commission-response";
import { SearchSymbolsModalComponent } from "../search-symbols-modal/search-symbols-modal.component";
import { PortfolioItem, PurchasePowerRes } from "src/app/models/purchase-power";
import { CurencyID } from "src/app/models/mutualFund";
import { catchError, debounceTime, distinctUntilChanged, finalize, map, takeUntil, tap } from "rxjs/operators";
import { forkJoin, of, Observable } from "rxjs";
import {OrderData} from "src/app/models/order";
import { SystemSettingsService } from "src/app/services/systemSettings.service";
import { OrderService } from "src/app/services/order.service";
import { checkSettingWithMarketId } from "src/app/models/settingsWithMarket";

interface orderType {
  TransactionId: number;
  TransactionNameE: String;
  TransactionTypeA: String;
}

@Component({
  selector: "app-order-buy",
  templateUrl: "./order-buy.component.html",
  styleUrls: ["./order-buy.component.scss"],
})
export class OrderBuyComponent implements OnInit {
  // company: any;
  orderData: OrderData;
  @Input() selectedRelCode;
  isBuyLoading = false;
  isSaved: boolean= false;
  marketDisbaled: boolean = true;
  maxLimit: number;
  inputUser: Account;
  isLoading = false;
  avgCommission: any;
  minCommission: any;
  minCommissionUSD: any;
  accList: any;
  clientData: any;
  custodianList: any;
  allCustodianList: any;
  orderTotal: number;
  totalCost: number;
  orderFees: number;
  isMarket: boolean;
  sendingOrder: boolean = false;
  company: CompanyListWithUpdates = {} as CompanyListWithUpdates;
  isMyShares: boolean = false;
  myShareSymbols: any;
  myCompanies: CompanyListWithUpdates[];
  settledQty: number;
  sellType: number = 0;
  currentPortfolioCompany: PortfolioElement;
  companyDetails: CompanyDetails;
  titleMessage: string;
  textConfirmMassage: string;
  inputCustodian: number;
  initqty: number;
  userProfile:Profile;
  AvbSetteled: number;
  AvbTPlusOne: number;
  AvbTPlusZero: number;
  isStopLoss: boolean;
  cashOrQyt: boolean = true;
  allowStopLoss: boolean = false;
  selectedOption: string = 'cashorQty'; 
  fallbackImage: string = 'assets/img/logoooo.png';
  readonly ALLOW_STOP_LOSS= "AllowStopLoss";
  UrlImage: string ;
  demandMethodsFiltered = [];
  currentPortfolioList: any[] = [];
  minTiffDate: Date;
  custodianSymbolSpecificMarginPercentage: number=-1;
  marginCustodianId: number;
  isCustodianSymbolMarginAvailable: boolean = true;
  TransactionTypes: orderType[] = [
    {
      TransactionId: 1,
      TransactionNameE: "Buy",
      TransactionTypeA: "شراء",
    },
    {
      TransactionId: 2,
      TransactionNameE: "Sell",
      TransactionTypeA: "بيع",
    },
    {
      TransactionId: 3,
      TransactionNameE: "Sell Same Day",
      TransactionTypeA: "بيع نفس اليوم ",
    },
    {
      TransactionId: 4,
      TransactionNameE: "Buy Same Day",
      TransactionTypeA: "شراء نفس اليوم",
    },
    {
      TransactionId: 5,
      TransactionNameE: "Sell T+1",
      TransactionTypeA: "T+1 بيع",
    },
    {
      TransactionId: 6,
      TransactionNameE: "Buy T+1",
      TransactionTypeA: "Buy T+1",
    },
  ];
  tiffFlagValue = [
    { value: 0, NameE: "Day", NameA: "يوم" },
    { value: 1, NameE: "Good Till Cancel", NameA: "صالح حتي الالغاء" },
    { value: 6, NameE: "Good Till Date", NameA: "صالح حتي التاريخ" },
    { value: 3, NameE: "Immediate", NameA: "فوري" },
  ];

  demandMethods = [
    {
      Id: "Written",
      Value: 0,
      NameE: "Written",
      NameA: "كتابة",
    },
    {
      Id: "Phone",
      Value: 1,
      NameE: "Phone",
      NameA: "تليفون",
    },
    {
      Id: "Fax",
      Value: 2,
      NameE: "Fax",
      NameA: "فاكس",
    },
    {
      Id: "Online",
      Value: 3,
      NameE: "Online",
      NameA: "اونلاين",
    },
    {
      Id: "Email",
      Value: 4,
      NameE: "Email",
      NameA: "بريد إلكتروني",
    },
  ];

  investmentData: InvestmentAmount;
  brokerInfo: any;


  customSearchFn(term: string, item: CompanyList) {
    term = term.toLowerCase();
    return (
      item?.ENG_NAME?.toLowerCase().includes(term) ||
      item?.ARB_NAME?.toLowerCase().includes(term) ||
      item?.Reuters?.toLowerCase().includes(term)
    );
  }

  onSelectChange() {
    this.fetchCompany().subscribe();
  }

  public tabIndex = 0;

  today = new Date();
  tomorrow = new Date(this.today.setDate(this.today.getDate() + 1));
  allowExceedSettledSellAmount : boolean;
  isFetchingUserData: boolean = false;
  companies: CompanyList[];
  allMarketNames: StockDetail[];
  exceedSettledSellAmountAlert: boolean;

  toggle(e: any) {
    if (e.value == "market") {
      this.isMarket = true;
      this.orderForm.get("price").disable();
      this.orderForm.get("price").patchValue(0);
    } else {
      this.isMarket = false;
      this.orderForm.get("price").enable();
      this.orderForm.get("price").patchValue(null);
    }
  }
  toggleStopLoss(e: any) {
    if (e.value == "stopLoss") {
      this.isStopLoss = true;
      this.cdr.detectChanges();
    } else {
      this.isStopLoss = false;
      this.cdr.detectChanges();
    }
  }
  // @Input() company: CompanyList;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private http: HttpClient,
    private accService: AccountService,
    private signalService: SignalRService,
    public datepipe: DatePipe,
    public translate: TranslateService,
    private dialog: MatDialog,
    private apiService: ApiService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private _marketDetail: MarketWatchDetailService,
    private cdr: ChangeDetectorRef,
    private settingsService: SystemSettingsService,
    private orderService: OrderService,
    private ngZone: NgZone
  ) {
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.accList = this.accList.filter(x => x.accountType != 3)
    this.tabIndex = this.data["type"];
    this.minTiffDate = new Date();

  }

  fetchInvestmentAmount() {
    this.apiService
      .fetchInvestmentAmount(
        this.company.SYMBOL_CODE.toString(),
        this.inputUser.relationCode.toString()
      )
      .subscribe((res) => {
        this.investmentData = res as InvestmentAmount;

        this.investmentData.investmentAmount = formatNumber(
          Number(this.investmentData.investmentAmount),
          "en-US",
          "1.0-0"
        );

        // Number(
        //   this.investmentData.investmentAmount.toLocaleString("en-GB")
        // )

        this.investmentData.targetWeight = Number(
          this.investmentData.targetWeight.toFixed(2)
        );

        this.investmentData.currentWeight = Number(
          this.investmentData.currentWeight.toFixed(2)
        );
      });
  }
  updateStockDetail(stock: CompanyList) {
    if (stock?.SYMBOL_CODE && this.allMarketNames) {
      let companyDetail = this.allMarketNames.find(
        (x) => x["SYMBOL_CODE"] === stock.SYMBOL_CODE
      );
      if (companyDetail) {
        stock.arb_shortname = companyDetail["arb_shortname"];
        stock.eng_shortname = companyDetail["eng_shortname"];
        stock.Reuters = companyDetail["Reuters"];
      }
    }
  }

  // oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';"
  priceDecimalInput(event: any) {
    let reg;
    switch (this.companyDetails.RoundDigits) {
      case 0:
        reg = /^[0-9]*$/;
        break;
      case 1:
        reg = /^[0-9]*(\.\d{0,1})?$/;
        break;
      case 2:
        reg = /^[0-9]*(\.\d{0,2})?$/;
        break;
      case 3:
        reg = /^[0-9]*(\.\d{0,3})?$/;
        break;
      case 4:
        reg = /^[0-9]*(\.\d{0,4})?$/;
        break;
      case 5:
        reg = /^[0-9]*(\.\d{0,5})?$/;
        break;
      default:
        reg = /^[0-9]*(\.\d{0,2})?$/;
        break;
    }

    // const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }
  fetchSymbolBO() {
    if (this.company?.SYMBOL_CODE) {
      this.apiService
        .fetchSymbolBO(this.company.SYMBOL_CODE)
        .subscribe({
          next: (res: CompanyDetails) => {
            this.companyDetails = res;
            // Simplified boolean assignment
            this.marketDisbaled = this.companyDetails.EnablePriceLimit;
            this.maxLimit = this.companyDetails.MaxLimit;
            this.initializeSettings(res.MarketID);
          },
          error: (err) => {
            // Handle error here if needed
          }
        });
    }
  }


  // fetchSymbolBO() {
  //   if (this.company.SYMBOL_CODE) {
  //     this.apiService
  //       .fetchSymbolBO(this.company.SYMBOL_CODE)
  //       .subscribe((res: CompanyDetails) => {
  //         this.companyDetails = res;
  //       });
  //   }
  // }

  fetchMySymbols() {
    this.apiService
      .fetchMySymbols(this.orderForm.get("client").value)
      .subscribe((res) => {
        this.myShareSymbols = res;
        if (this.myShareSymbols?.length > 0)
          this.myCompanies = this.companies.filter((company) => {
            return this.myShareSymbols.indexOf(company.SYMBOL_CODE) != -1;
          });
      });
  }

  get companiesList() {
    if (this.isMyShares) return this.myCompanies;
    else return this.companies;
  }


  fetchCommissions() {
    this.http.get<CommissionResponse>(`${UrlConstants.backofficeUrl}/api/Settings/GetConfiguredCommissions`)
      .subscribe((res) => {
        this.avgCommission = res.AvgCommission;
        this.minCommission = res.MinCommission;
        this.minCommissionUSD = res.MinCommissionUSD;
      });
  }

  calculateFees(orderValue) {
    let feePercentage = this.avgCommission;

    if (orderValue == 0) {
      feePercentage == 0;
    }

    let totalFees = orderValue * feePercentage;

    if (this.company.CURRENCY == 1) {
      // For EGP
      if (totalFees < this.minCommission) {
        totalFees = this.minCommission;
      }
    } else {
      // For USD or other currencies
      if (totalFees < this.minCommissionUSD) {
        totalFees = this.minCommissionUSD;
      }
    }

    return totalFees;
  }

  fetchCompany(): Observable<CompanyList | null> {
    if (!this.company?.SYMBOL_CODE) {
      return of(null);
    }

    const url = `${UrlConstants.feedUrl}/api/Feed/GetMarketWatchForSymbol?SYMBOL_CODE=${this.company.SYMBOL_CODE}`;
    return this.http.get<CompanyList>(url).pipe(
      tap((res: CompanyList) => {
        this.company = res as CompanyList;
        this.fetchSymbolBO();
        this.fetchSymbolPortfolio(this.company.SYMBOL_CODE);
        this.setImageUrl(this.company.SYMBOL_CODE);
      }),
      catchError((err) => {
        return of(null);
      })
    );
  }

fetchSymbolPortfolio(symbolCode: string) {
  const clientCode = this.orderForm.get("client")?.value;
this.isLoading = true;
this.isBuyLoading = true;
  if (!clientCode || !symbolCode) return;

  this.http
    .get<ClientDataPortfolio>(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientPortfolio?relationCode=${clientCode}&symbolCode=${symbolCode}`
    )
    .subscribe({
      
      next: (res) => {
        this.isLoading = false;
this.isBuyLoading = false;
        const { EGPPortfolio, USDPortfolio, RatedPortfolio } = res;

        if (RatedPortfolio?.Portfolio?.length > 0) {
          let portfolioList = [];

          if (this.company.CURRENCY === 1 && EGPPortfolio?.Portfolio?.length > 0) {
            portfolioList = EGPPortfolio.Portfolio;
          } else if (this.company.CURRENCY === 2 && USDPortfolio?.Portfolio?.length > 0) {
            portfolioList = USDPortfolio.Portfolio;
          }

          if (portfolioList.length > 0) {
              this.currentPortfolioList = portfolioList;
            const matched = this.inputCustodian
              ? portfolioList.find(p => p.CustodianCode === this.inputCustodian)
              : null;

            this.currentPortfolioCompany = matched ?? portfolioList[0];

            if (this.currentPortfolioCompany?.CustodianCode) {
              this.inputCustodian = this.currentPortfolioCompany.CustodianCode;
              this.f.custodian.patchValue(this.inputCustodian);
                 const portfolioCustodianCodes = [...new Set(portfolioList.map(p => Number(p.CustodianCode)))];

              switch (this.tabIndex) {
                case 1:
                  // this.custodianList = this.allCustodianList.filter(
                  //   c => Number(c.CustodianCode) === Number(this.inputCustodian)
                  // );
                 this.custodianList = this.allCustodianList.filter(c => portfolioCustodianCodes.includes(Number(c.CustodianCode))
        );
                  break;

                case 0:
                  this.custodianList = [...this.allCustodianList];
                  break;
              }
            }

            this.sellTypeChange();
          } else {
            this.settledQty = null;
          }
        } else {
          this.settledQty = null;
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.settledQty = null;
        this.isLoading = false;
this.isBuyLoading = false;
      }
    });



}

  orderForm = new FormGroup({
    client: new FormControl("", Validators.required),
    qty: new FormControl("", Validators.required),
    price: new FormControl("", Validators.required),
    custodian: new FormControl("", Validators.required),
    execRule: new FormControl("", Validators.required),
    validTill: new FormControl("", Validators.required),
    tiffDate: new FormControl(),
    demandMethod: new FormControl(3, Validators.required),
    minFillVolume: new FormControl(),
  });

  sellTypeChange() {
    if (this.tabIndex == 1 && this.currentPortfolioCompany) {
      if (this.sellType == 2)
        this.settledQty = this.currentPortfolioCompany.AvbSetteledQty;
      else if (this.sellType == 3)
        this.settledQty = this.currentPortfolioCompany.AvbTPlusZeroQty;
      else if (this.sellType == 5)
        this.settledQty = this.currentPortfolioCompany.AvbTPlusOneQty;
    }
    this.f.qty.patchValue(null);
  }

  qtyClicked() {
    if (this.settledQty != 0) this.f.qty.patchValue(this.settledQty);
  }

  orderType(type) {
    let typeName = this.TransactionTypes.find((trans) => {
      return trans.TransactionId == type;
    });

    return this.translate.currentLang == "en"
      ? typeName.TransactionNameE
      : typeName.TransactionTypeA;
  }
  calculateMakretCost(quantity, maxLimit) {
    this.totalCost = quantity * maxLimit;
  }


  getTiffFlag(value) {
    // if (value != null)
    //   return this.tiffFlagValue.find((x) => x.value == value).viewValue;
    // else return null;

    let tiffFlag = this.tiffFlagValue.find((trans) => {
      return trans.value == value;
    });

    return this.translate.currentLang == "en" ? tiffFlag.NameE : tiffFlag.NameA;
  }

  custodianName(value) {
    return this.custodianList.find((item) => item.CustodianCode == value)
      .CustodianNameE;
  }

  sendOrder(type) {

    this.orderTotal = parseFloat(parseFloat(this.orderTotal.toString()).toFixed(2));
    this.orderFees = this.calculateFees(this.orderTotal);
    this.totalCost = parseFloat((this.orderTotal + this.orderFees).toFixed(2));

if (this.inputUser?.IsMargin && !this.isCustodianSymbolMarginAvailable && type === 1) {
      const errorMsg = this.translate.currentLang === 'ar' 
        ? 'هذا السهم غير متاح للتمويل مع أمين الحفظ الحالي'
        : 'This stock is not available for margin with the current custodian';
      Swal.fire({
        icon: 'error',
        title: this.translate.instant('error-msg'),
        text: errorMsg,
        confirmButtonText: this.translate.instant('yes')
      });
      return;
    }
    if (
      (this.company.CURRENCY === 1 && this.clientData?.purchasePower?.EGP > this.totalCost) ||
      (this.company.CURRENCY === 2 && this.clientData?.purchasePower?.USD > this.totalCost) ||
      this.brokerInfo?.IsAllowExceedPP ||
      type === 2
    ) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد اضافة امر";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل اضافة الامر
     <span style="${type == 2 ? "color:red" : "color:green"}"> ${type == 2 ? this.orderType(this.sellType) : this.orderType(type)
          } </span>
     الكمية: ${this.orderForm.value.qty}
     السهم: ${this.company.ARB_NAME}
     السعر:  ${this.orderForm.value.price}
     الصلاحية: ${this.orderForm.value.validTill == 6 &&
            this.orderForm.value.validTill != null
            ? this.datepipe.transform(this.orderForm.value.tiffDate)
            : ""
          } ${this.getTiffFlag(this.orderForm.value.validTill)}
      امين الحفظ: ${this.custodianName(this.orderForm.value.custodian)}
      قيمة الامر: ${this.orderTotal}  ${this.company.CURRENCY == 1 ? "جنيه مصري" : "دولار"} 
      الرسوم: ${this.orderFees.toFixed(2)}  ${this.company.CURRENCY == 1 ? "جنيه مصري" : "دولار"} 
      القيمة الاجمالية: ${this.totalCost}  ${this.company.CURRENCY == 1 ? "جنيه مصري" : "دولار"} `;

      }

      if (this.translate.currentLang == "en") {
        this.titleMessage = "Confirm New Order";
        this.textConfirmMassage = `Please check order details before confirmation
     Order Type: ${type == 2 ? this.orderType(this.sellType) : this.orderType(type)
          }  Qty: ${this.orderForm.value.qty}
     Stock: ${this.translate.currentLang == "en"
            ? this.company.ENG_NAME
            : this.company.ARB_NAME
          }
     Price: ${this.isMarket
            ? this.translate.instant("market")
            : this.orderForm.value.price
          }
     Validity: ${this.getTiffFlag(this.orderForm.value.validTill)} ${this.orderForm.value.validTill == 6 &&
            this.orderForm.value.validTill != null
            ? this.datepipe.transform(this.orderForm.value.tiffDate)
            : ""
          }
    Custodian: ${this.custodianName(this.orderForm.value.custodian)}
    Order Value:  ${this.orderTotal}  ${this.company.CURRENCY == 1 ? "EGP" : "USD"} 
    Fees:  ${this.orderFees.toFixed(2)}  ${this.company.CURRENCY == 1 ? "EGP" : "USD"} 
    Total:  ${this.totalCost}  ${this.company.CURRENCY == 1 ? "EGP" : "USD"}`;


      }
      this.titleMessage =
        this.translate.currentLang == "en"
          ? "Confirm New Order"
          : "تأكيد اضافة امر";
      Swal.fire({
        title: this.titleMessage,
        html: "<pre>" + this.textConfirmMassage + "<pre>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let orderData: OrderData = 
          {
            SymbolCode: this.company.SYMBOL_CODE,
            Qty: this.orderForm.get("qty").value,
            Price: this.orderForm.get("price").value,
            TakeMarketPrice: this.isMarket,
            ISMSCDBook: false,
            OrderType: type == 2 ? this.sellType : 1,
            ApprovedStatus: type == 1 && !this.isValidOrder ? 2 : null,
            TiffFlag: this.orderForm.get("validTill").value,
            TiffDate: this.orderForm.get("tiffDate").value,
            FillFlag: this.orderForm.get("execRule").value,
            relationCode: this.orderForm.get("client").value,
            CustodianCode: this.orderForm.get("custodian").value,
            ISOPR: false,
            DemandMethod: this.orderForm.get("demandMethod").value,
            MinFillVolume: this.orderForm.get("minFillVolume").value,
          };
          if (this.isStopLoss) {
            orderData = {
              ...orderData,
              FixTrigger: {
                Price: this.isMarket ? this.maxLimit : this.orderForm.get("price").value,
              },
            };
          }
          this.sendingOrder = true;

          this.orderService.createOrder(orderData).subscribe({
            next: (res) => {
              this.sendingOrder = false;
              if (res["Errors"]?.length > 0) {
                this.dialog.closeAll();
                this.toastr.error("", res["Errors"][0], {
                  timeOut: 15000,
                  positionClass: "toast-bottom-center",
                  closeButton: true,
                });
              } else {
                this.dialog.closeAll();
                this.toastr.success("", "Order created successfully", {
                  timeOut: 15000,
                  positionClass: "toast-bottom-center",
                  closeButton: true,
                });
              }
            },
            error: () => {
              this.sendingOrder = false;
              this.toastr.error("", "Failed to create order", {
                timeOut: 15000,
                positionClass: "toast-bottom-center",
                closeButton: true,
              });
            },
          });
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.sendingOrder = false;
        }
      });
    }
    else {
      this.titleMessage =
        this.translate.currentLang == "en"
          ? "this action not allowed"
          : "خطأ فى الاستخدام";
    }
  }
  get purchasePowerState() {
    return this.shouldExpandPurchasePower ? 'full' : 'half';
  }
  get shouldExpandPurchasePower() {
    return !(this.orderTotal > 0 || (this.isMarket && this.totalCost > 0));
  }
  get isNewFormValid(): boolean {
    const controlsToValidate = ['client', 'custodian', 'execRule', 'validTill', 'demandMethod'];
    return controlsToValidate.every(control => this.orderForm.get(control)?.valid);
  }
 clickedS() {
   this.sellTypeChange();
   this.sellType = 2;
   this.qtyClickedS();

  }
  clickedT0() {
    this.sellTypeChange();
    this.sellType = 3;
    this.qtyClickedT0();

  }
  clickedT1() {
    
    this.sellTypeChange();
    this.sellType = 5;
    this.qtyClickedT1();


  }

  qtyClickedS() {
    
    if ((this.tabIndex == 1 )&&  this.AvbSetteled != 0) this.f.qty.patchValue(this.AvbSetteled)
      else this.f.qty.patchValue(null);
  }
  qtyClickedT1() {
    
    if ((this.tabIndex == 1 )&&this.AvbTPlusOne != 0) this.f.qty.patchValue(this.AvbTPlusOne);
    else this.f.qty.patchValue(null);

  }  
  qtyClickedT0() {
    
    if ((this.tabIndex == 1 )&&this.AvbTPlusZero != 0) this.f.qty.patchValue(this.AvbTPlusZero);
    else this.f.qty.patchValue(null);

  }

  onSelectClient(relCode) {
    this.isFetchingUserData = true;
    this.http
    .get(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientProfile?relationCode=${relCode}`
    ).subscribe((res) => {
      if (res) {
        this.userProfile= res as Profile;
      }
    });
    //fetch Purchase Power
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientPurchasePower?relationCode=` +
        relCode
      )
      .subscribe((res) => {
        if (res) {
          this.isFetchingUserData = false;
          this.clientData = res;
          this.fetchMySymbols();
          this.fetchCompany().subscribe(() => {
          this.fetchClientStocks(relCode);
          });
        }
      });

    //fetch Client Custodian
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientCustodianList?relationCode=` +
        relCode
      )
      .subscribe((res) => {
        if (res) {          
          this.custodianList = res;
          this.allCustodianList = res;
          if (!this.inputCustodian)
            this.f.custodian.patchValue(this.allCustodianList[0].CustodianCode); // set first custodian
          this.f.execRule.patchValue(0); //set regular
          this.f.validTill.patchValue(0); //set today
          this.f.demandMethod.patchValue(3);
        }
      });
  }

  get f() {
    return this.orderForm.controls;
  }

  get isValidOrder() {
    if (this.isMarket) return (
      this.totalCost <
      (this.company.CURRENCY == 2
        ? this.clientData?.purchasePower?.USD
        : this.clientData?.purchasePower?.EGP) && this.totalCost > 0
    ); else
      return (
        this.orderTotal <
        (this.company.CURRENCY == 2
          ? this.clientData?.purchasePower?.USD
          : this.clientData?.purchasePower?.EGP) && this.orderTotal > 0
      );
  }
  get isValidOrderCost() {
    if (this.isMarket) return (
      this.totalCost <
      (this.company.CURRENCY == 2
        ? this.clientData?.purchasePower?.USD
        : this.clientData?.purchasePower?.EGP) && this.totalCost > 0
    );
    else
      return (
        this.totalCost <
        (this.company.CURRENCY == 2
          ? this.clientData?.purchasePower?.USD
          : this.clientData?.purchasePower?.EGP) && this.totalCost > 0
      );
  }

  //Valid Till
  // if (value == 0 || value == 1) {
  //   tiffDate = null;
  // }
  // if (value == 6) {
  //   DatePicker.showDatePicker(context,
  //       showTitleActions: true,
  //       minTime: DateTime(2019, 1, 1),
  //       maxTime: DateTime.now(),
  //       onConfirm: (date) {
  //     setState(() {
  //       tiffDate = date;
  //       print(tiffDate);
  //     });
  //   },
  //       currentTime: DateTime.now(),
  //       locale: LocaleType.en);
  // }

  ngAfterViewInit(): void {


    this.orderForm.valueChanges.subscribe((val) => {
      this.orderTotal = this.orderForm.get("price").value * this.orderForm.get("qty").value;

      this.orderFees = this.calculateFees(this.orderTotal);
      this.totalCost = this.orderTotal + this.orderFees;
      this.orderTotal = this.isMarket ? this.orderForm.get("qty").value * this.maxLimit : this.orderTotal;
      this.orderFees = this.isMarket ? this.calculateFees(this.orderForm.get("qty").value * this.maxLimit) : this.orderFees;
      this.totalCost = this.isMarket
        ? (this.orderForm.get("qty").value * this.maxLimit > 0
          ? ((this.orderForm.get("qty").value * this.maxLimit) + this.orderFees)
          : 0)
        : this.totalCost;
    });
    this.isBuyLoading = true;
    const buyInterval = setInterval(() => {
      if (this.company && this.avgCommission) {
        clearInterval(buyInterval);
        this.isBuyLoading = false;
      }
    }, 100);
    this.isLoading = true;
    const interval = setInterval(() => {
      if (this.totalCost == 0 || this.totalCost == null)
        this.isLoading = false;
      else if (this.company && this.avgCommission && this.myCompanies && this.clientData
        && this.myShareSymbols && this.companyDetails && this.currentPortfolioCompany
      ) {
        clearInterval(interval);
        this.orderForm.get("qty").patchValue(this.initqty);
        this.isLoading = false;
      }
    }, 100);
  }
   private initializeSettings(marketId:number): void {
    // Holding Share Validation Setting
    const holdingShareValidationRequest : checkSettingWithMarketId={
      name:"Holding Share Validation",
      marketId:marketId
    }
    this.settingsService.checkSettingWithMarketId(holdingShareValidationRequest).subscribe(
      res => {
        this.allowExceedSettledSellAmount = res;
        this.cdr.detectChanges();
      }
    )  
  }

  ngOnInit(): void {
    this.demandMethodsFiltered = this.demandMethods.filter(dm => dm.Value === 3);
    this.setupOrderFormSubscription();
    this.settingsService.checkSetting(this.ALLOW_STOP_LOSS).subscribe(isAllowed => {
      this.allowStopLoss = isAllowed;      
    }, error => {
    });
    this.fetchCommissions();
    this.inputUser = this.accList[0];

    if (this.data["currentUser"] != null){
      this.orderForm.get("client").patchValue(this.data["currentUser"]) 
    }
    else this.orderForm.get("client").patchValue(this.accList[0].relationCode);

    if (this.sharedService.allMarketCompanies) {
      this.companies = this.sharedService.allMarketCompanies;
      this.onSelectClient(this.orderForm.get("client").value);
    } else
      this.apiService.fetchAllMarketWatch().subscribe((res) => {
        this.companies = res as CompanyList[];
        this.onSelectClient(this.orderForm.get("client").value);
      });

    if (this.data["symbol"]) {
      this.company.SYMBOL_CODE = this.data["symbol"];
      if (this.data["custodianCode"]) {
        this.inputCustodian = this.data["custodianCode"];
        this.f.custodian.patchValue(this.inputCustodian);
      }

      this.fetchCompany().subscribe();
    }
    if (this.data["price"] != null) {
      this.orderForm.get("price").patchValue(this.data["price"]);
      this.orderForm.get("qty").patchValue(this.data["qty"]);
      this.maxLimit = this.companyDetails?.MaxLimit;

    }



    // });


    this.signalService.marketChanges.subscribe((res: any) =>
      res.forEach((element) => {
        if (element.SYMBOL_CODE == this.company.SYMBOL_CODE) {
          this.updateStockDetail(element);
          this.company = element;
          return;
        }
      })
    );

    if (this._marketDetail.marketNames)
      this.allMarketNames = this._marketDetail.marketNames.getValue();
    this._marketDetail.namesSubject.subscribe((res) => {
      this.allMarketNames = res as StockDetail[];
    });

    this.orderForm.valueChanges.subscribe((val) => {
      this.orderTotal =
        this.orderForm.get("price").value * this.orderForm.get("qty").value;
    });

    this.orderForm.get("validTill").valueChanges.subscribe((res) => {
      if (res == "6") {
        this.orderForm.get("tiffDate").setValidators(Validators.required);
        this.orderForm.get("tiffDate").updateValueAndValidity();
      } else if (res == "0" || res == "1") {
        this.orderForm.get("tiffDate").clearValidators();
        this.orderForm.updateValueAndValidity();

        this.orderForm.get("tiffDate").patchValue(null);
      }
    });

    this.brokerInfo = JSON.parse(localStorage.getItem("brokerInfo"));

  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onTabChanged(event) {
    this.orderForm.reset();
    this.orderForm
      .get("client")
      .patchValue(this.data["currentUser"] || this.accList[0].relationCode); // set first acc
        const portfolioCustodianCodes = this.currentPortfolioList?.length > 0
    ? [...new Set(this.currentPortfolioList.map(p => Number(p.CustodianCode)))]
    : [];
      switch (this.tabIndex) {
      case 1:
        // this.custodianList = this.allCustodianList.filter(
        //   c => Number(c.CustodianCode) === Number(this.inputCustodian)
        // );
       this.custodianList = this.allCustodianList.filter(c => portfolioCustodianCodes.includes(Number(c.CustodianCode))
      );

        break;

      case 0:
        this.custodianList = [...this.allCustodianList];
        break;
    }
    if (!this.inputCustodian){

      this.f.custodian.patchValue(this.custodianList[0].CustodianCode); // set first custodian
    }
    else
    {
      this.f.custodian.patchValue(this.inputCustodian);
    }
    this.f.execRule.patchValue(0); //set regular
    this.f.validTill.patchValue(0); //set today
    this.f.demandMethod.patchValue(3);

  }
  private setupOrderFormSubscription(): void {
    const orderFormSub = this.orderForm.valueChanges
      .pipe(
        debounceTime(100), // Prevent excessive calculations
        distinctUntilChanged(), // Only react to actual changes
        map(formValue => ({
          price: formValue.price || 0,
          qty: formValue.qty || 0
        }))
      )
      .subscribe(({ price, qty }) => {
        this.calculateOrderTotals(price, qty);
      });

  }

  private calculateOrderTotals(price: number, qty: number): void {
    try {
      // Basic order total calculation
      const baseOrderTotal = price * qty;
      
      // Handle market vs limit orders
      if (this.isMarket && this.maxLimit) {
        this.orderTotal = qty * this.maxLimit;
        this.orderFees = this.calculateFees(this.orderTotal);
        this.totalCost = this.orderTotal > 0 ? this.orderTotal + this.orderFees : 0;
      } else {
        this.orderTotal = baseOrderTotal;
        this.orderFees = this.calculateFees(this.orderTotal);
        this.totalCost = this.orderTotal + this.orderFees;
      }
      
      //Sell Order validation
      if(this.tabIndex==1 )
      {
       switch(this.sellType) {
  case 0:
   // this.selectSellTypeAlert = true;
    this.exceedSettledSellAmountAlert = false;
    break;
    
  case 2:
    this.exceedSettledSellAmountAlert = this.currentPortfolioCompany.SetteledQty < qty;
    //this.selectSellTypeAlert = false;
    break;
    
  case 3:
    this.exceedSettledSellAmountAlert = this.currentPortfolioCompany.AvbTPlusZeroQty < qty;
    //this.selectSellTypeAlert = false;
    break;
    
  case 5:
    this.exceedSettledSellAmountAlert = this.currentPortfolioCompany.AvbTPlusOneQty < qty;
    //this.selectSellTypeAlert = false;
    break;
    
  default:
    //this.selectSellTypeAlert = true;
    this.exceedSettledSellAmountAlert = false;
}
      }
      // Ensure non-negative values
      this.orderTotal = Math.max(0, this.orderTotal);
      this.orderFees = Math.max(0, this.orderFees);
      this.totalCost = Math.max(0, this.totalCost);

    } catch (error) {
      this.resetOrderTotals();
    }
  }

  private resetOrderTotals(): void {
    this.orderTotal = 0;
    this.orderFees = 0;
    this.totalCost = 0;
  }
  selectCompany($event?:any) {
    // $event? this.saveTabState($event): null;
    const dialogRef =this.dialog.open(SearchSymbolsModalComponent, {
      panelClass: ["modal-width","modal-width-order-buy"],
      data:{
        isCompanySearch: true
      }
    });
    const instance = dialogRef.componentInstance;

    instance.companyChanged.subscribe((company: CompanyListWithUpdates) => {
      this.company = company;
      this.company.SYMBOL_CODE =company.SYMBOL_CODE;
      this.fetchSymbolBO();
      this.fetchSymbolPortfolio(this.company.SYMBOL_CODE);
      this.setImageUrl(this.company.SYMBOL_CODE);
      this.fetchClientStocks(this.inputUser.relationCode.toString());


    });
  }
  private setDefaultValues(): void {
    this.AvbSetteled = 0;
    this.AvbTPlusZero = 0;
    this.AvbTPlusOne = 0;
}
fetchClientStocks(selectedAcc?): void {
    // Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
   this.ngZone.run(() => {
        this.isLoading = true;
        this.isBuyLoading = true;
    });
    
    try {
        // Ensure selectedAcc is valid before proceeding
        if (!selectedAcc) {
            this.setDefaultValues();
           this.ngZone.run(() => {
                this.isLoading = false;
                this.isBuyLoading = false;
            });
            return;
        }

        else{
          this.inputUser = this.accList.find(acc => acc.relationCode === selectedAcc);
        }
        // Use forkJoin to wait for both operations to complete
        forkJoin({
            portfolio: this.apiService.fetchClientStocks(selectedAcc),
            company: this.fetchCompany()
        }).pipe(
            finalize(() => {
                // Use setTimeout to defer the loading state change
  this.ngZone.run(() => {
                    this.isLoading = false;
                    this.isBuyLoading = false;
                });
            })
        ).subscribe({
            next: (results) => {
                const portfolioRes = results.portfolio;
                
                if (!portfolioRes) {
                    this.setDefaultValues();
                    return;
                }

                const typedPortfolioRes = portfolioRes as PurchasePowerRes;
                let portfolio: PortfolioItem[] | undefined = undefined;

                if (this.company.CURRENCY === CurencyID.EGP) {
                    portfolio = typedPortfolioRes.EGPPortfolio?.Portfolio;
                } else if (this.company.CURRENCY === CurencyID.USD) {
                    portfolio = typedPortfolioRes.USDPortfolio?.Portfolio;
                }


                if (!portfolio) {
                    this.setDefaultValues();
                    return;
                }

                const stock = portfolio.find(item => item.SymbolCode === this.company.SYMBOL_CODE && item.CustodianCode === this.inputCustodian);
                
                this.AvbSetteled = stock?.AvbSetteledQty ?? 0;
                this.AvbTPlusZero = stock?.AvbTPlusZeroQty ?? 0;
                this.AvbTPlusOne = stock?.AvbTPlusOneQty ?? 0;

                // Handle margin logic if needed
                if (this.inputUser != null && 
                    this.company.SYMBOL_CODE != null && 
                    this.inputUser.IsMargin
                  && this.inputUser.accountType === 2) {
                     var custodian =  this.apiService.getCustodianByRelationCode(selectedAcc);
                      custodian.subscribe((res:any)=>{
                        this.marginCustodianId = res?.CustodianCode ?? -1;
                        if (this.marginCustodianId != -1) {
                        var filter = {
                          CustodianCode: this.marginCustodianId,
                        }
                        this.accService
                          .GetCustodianSymbols(filter)
                          .subscribe((res) => {
                         const symbolData = res.find(x => x.SymbolCode === this.company.SYMBOL_CODE);
                            this.custodianSymbolSpecificMarginPercentage = symbolData?.MarginPercentage ?? -1;
                            this.isCustodianSymbolMarginAvailable = symbolData != null && symbolData.MarginPercentage != null;
                            this.cdr.detectChanges();
                          }); 
                      }
                      
                      this.fetchInvestmentAmount();
                      });                                            
                }
                 else {
                  this.isCustodianSymbolMarginAvailable = true;
                  this.custodianSymbolSpecificMarginPercentage = -1;
                }
                this.checkQty();
            },
            error: (error) => {
                this.setDefaultValues();
            }
        });

    } catch (error) {
        this.setDefaultValues();
        this.ngZone.run(() => {
            this.isLoading = false;
            this.isBuyLoading = false;
        });
    }
}

setImageUrl(fileName: string): Promise<string | null> {
  const baseUrl = 'assets/stocks/';
 //  const fileExtensions = ['.png', '.svg'];
  const fileExtensions = [ '.svg'];
 
  let imageUrl: string = this.fallbackImage; // Default to fallback image

 return new Promise((resolve) => {
   let found = false;
   let checkedCount = 0;

  fileExtensions.forEach((ext) => {
     const filePath = `${baseUrl}${fileName}${ext}`;

     this.http.head(filePath, { responseType: 'text' }).pipe(
       catchError(() => of(null)) // Suppress 404 errors
     ).subscribe((response) => {
       if (response !== null && !found) {
         found = true;
       this.UrlImage = filePath
         
         resolve(filePath);

       }
       checkedCount++;
       if (checkedCount === fileExtensions.length && !found) {
         resolve(null);
       }
     });
   });
 });
}
    isPriceInvalid(): boolean {
      const price = this.orderForm.value.price;
      return typeof price === 'string' && /^0+$/.test(price.trim());
    }
      checkQty() {
    if (this.AvbSetteled ==0 && this.AvbTPlusOne==0) {
      this.clickedT0();
    }
        if (this.AvbTPlusZero ==0 && this.AvbTPlusOne==0) {
      this.clickedS();
    }     
       if (this.AvbTPlusZero ==0 && this.AvbSetteled==0) {
      this.clickedT1();
    }
  }
    onselectedCustodian(event: Event)
    {
      const selectedOption = event?.target as HTMLSelectElement;
      const custodianCode = selectedOption?.value;
    if(custodianCode && this.tabIndex == 1)
    {
       this.inputCustodian = parseInt(custodianCode) ;
       this.fetchClientStocks(this.orderForm.get("client").value);
      
    }
    else return;
  }
}
